/* Beyond Bottleshop — floating controls (hamburger overlay + shop button) */
(function () {
  var fab = document.getElementById('bbFab');
  var menu = document.getElementById('bbFabMenu');
  var headerMenu = document.getElementById('bbHeaderMenu');
  var overlay = document.getElementById('bbOverlay');
  var closeBtn = document.getElementById('bbOverlayClose');
  if (!fab || !menu || !overlay) return;

  // Reveal the floating controls once the user scrolls past the fold.
  var ticking = false;
  function update() {
    var past = window.pageYOffset > window.innerHeight * 0.85;
    fab.classList.toggle('is-visible', past);
    ticking = false;
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
  }, { passive: true });
  window.addEventListener('resize', update);
  update();

  // Overlay menu open/close.
  function openMenu() {
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    menu.setAttribute('aria-expanded', 'true');
    if (headerMenu) headerMenu.setAttribute('aria-expanded', 'true');
    document.body.classList.add('bb-noscroll');
  }
  function closeMenu() {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    menu.setAttribute('aria-expanded', 'false');
    if (headerMenu) headerMenu.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('bb-noscroll');
  }
  menu.addEventListener('click', openMenu);
  if (headerMenu) headerMenu.addEventListener('click', openMenu);
  if (closeBtn) closeBtn.addEventListener('click', closeMenu);
  overlay.addEventListener('click', function (e) { if (e.target === overlay) closeMenu(); });
  Array.prototype.forEach.call(overlay.querySelectorAll('a'), function (a) {
    a.addEventListener('click', closeMenu);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.keyCode === 27) closeMenu();
  });
})();
